import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import TranscriptExportVtt from './TranscriptExportVtt.vue'

declareVconsoleComponent('transcriptExportVtt', TranscriptExportVtt, 'transcript:export_vtt')